"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("../../Types");
var Util_1 = require("../../Services/Util");
var InputValidation = /** @class */ (function () {
    function InputValidation(useCustomValidation, customError, patern) {
        var _this = this;
        if (useCustomValidation === void 0) { useCustomValidation = false; }
        if (customError === void 0) { customError = ""; }
        if (patern === void 0) { patern = /^$/; }
        this.reset = function () {
            _this.Validation.reset();
            return _this;
        };
        this.validate = function (value) {
            if (typeof value !== "string" || value === undefined || value === null || value === "") {
                _this.Validation = new Types_1.Validation(_this.Resources.Registration_Validation_RequiredField, Types_1.InputValidationState.invalid);
            }
            else if (_this.UseCustomValidation) {
                if (!_this.Patern.test(value)) {
                    _this.Validation = new Types_1.Validation(_this.CustomError, Types_1.InputValidationState.invalid);
                }
                else {
                    _this.Validation.reset();
                }
            }
            else {
                _this.Validation.reset();
            }
            return _this;
        };
        this.isValid = function () {
            return _this.Validation.isValid();
        };
        this.isInvalid = function () {
            return _this.Validation.isInvalid();
        };
        this.Validation = new Types_1.Validation();
        this.UseCustomValidation = useCustomValidation;
        this.CustomError = customError;
        this.Patern = patern;
        this.Resources = {};
        Util_1.GetResources(function (resources) { _this.Resources = resources; });
    }
    return InputValidation;
}());
exports.InputValidation = InputValidation;
//# sourceMappingURL=InputValidation.js.map